module.exports = __webpack_public_path__ + "fonts/ClashDisplay-Medium.a55835c.ttf";